
import GlobalHeader from '../../../components/feature/GlobalHeader';

export default function Header() {
  return <GlobalHeader />;
}
